export default {
  common: {
    loading: 'Loading...',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    search: 'Search',
    noData: 'No data available',
    error: 'An error occurred',
    success: 'Operation successful',
    offline: 'You are offline',
    online: 'Back online'
  },
  auth: {
    login: {
      title: 'Welcome Back',
      subtitle: 'Sign in to continue to Maid Mate',
      submit: 'Sign In'
    },
    register: {
      title: 'Create Account',
      subtitle: 'Join Maid Mate today',
      submit: 'Create Account'
    },
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    orContinueWith: 'Or continue with',
    agreeTerms: 'I agree to the Terms of Service and Privacy Policy',
    passwordStrength: {
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong'
    }
  },
  validation: {
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordMismatch: 'Passwords do not match'
  },
  tasks: {
    title: 'Tasks',
    createTask: 'Create Task',
    taskDetails: 'Task Details',
    pending: 'Pending',
    inProgress: 'In Progress',
    finished: 'Finished',
    completed: 'Completed',
    cancelled: 'Cancelled',
    startTask: 'Start Task',
    finishTask: 'Finish Task',
    completeTask: 'Confirm Completion',
    cancelTask: 'Cancel Task',
    rateTask: 'Rate Task',
    taskTitle: 'Title',
    taskNotes: 'Notes',
    dueDate: 'Due Date',
    assignedTo: 'Assigned To',
    noTasks: 'No tasks found',
    proofImages: 'Proof Images',
    addProofImage: 'Add Proof Image'
  },
  expenses: {
    title: 'Expenses',
    createExpense: 'Record Expense',
    expenseDetails: 'Expense Details',
    amount: 'Amount',
    currency: 'Currency',
    category: 'Category',
    description: 'Description',
    date: 'Date',
    receipt: 'Receipt',
    pending: 'Pending Verification',
    verified: 'Verified',
    verify: 'Verify',
    reports: 'Reports',
    totalAmount: 'Total Amount',
    byCategory: 'By Category',
    noExpenses: 'No expenses found',
    from: 'From',
    to: 'To'
  },
  quotations: {
    title: 'Quotations',
    createQuotation: 'Create Quotation',
    quotationDetails: 'Quotation Details',
    draft: 'Draft',
    submitted: 'Submitted',
    approved: 'Approved',
    rejected: 'Rejected',
    submit: 'Submit for Approval',
    approve: 'Approve',
    reject: 'Reject',
    complete: 'Mark Complete',
    rejectionReason: 'Rejection Reason',
    noQuotations: 'No quotations found',
    vendorName: 'Vendor Name',
    validUntil: 'Valid Until',
    imageUrl: 'Image URL'
  },
  mealplans: {
    title: 'Meal Plans',
    createMealPlan: 'Create Meal Plan',
    mealPlanDetails: 'Meal Plan Details',
    day: 'Day',
    week: 'Week',
    startDate: 'Start Date',
    endDate: 'End Date',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    snack: 'Snack',
    getRecommendation: 'Get AI Recommendation',
    noMealPlans: 'No meal plans found'
  },
  favor: {
    title: 'Dietary Preferences',
    allergies: 'Allergies',
    dietaryRestrictions: 'Dietary Restrictions',
    preferences: 'Food Preferences',
    addAllergy: 'Add Allergy',
    addRestriction: 'Add Restriction',
    addPreference: 'Add Preference'
  },
  household: {
    title: 'Household',
    profile: 'Household Profile',
    name: 'Household Name',
    createHousehold: 'Create Household',
    joinHousehold: 'Join Household',
    householdName: 'Household Name',
    notes: 'Notes',
    members: 'Members',
    memberHistory: 'Member History',
    qrCode: 'QR Code',
    scanQR: 'Scan QR Code',
    leaveHousehold: 'Leave Household',
    deleteHousehold: 'Delete Household',
    selectHousehold: 'Select Household',
    noHouseholds: 'No households found',
    noHousehold: 'No household selected',
    create: 'Create Household',
    createdAt: 'Created At',
    joinLink: 'Join Link',
    joinLinkDesc: 'Share this link to invite members to your household.',
    generateLink: 'Generate Join Link',
    linkExpires: 'Expires',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Deleting the household will remove all data and members.',
    deleteConfirmTitle: 'Delete Household?',
    deleteConfirmDesc: 'This action cannot be undone. All tasks, expenses, and data will be permanently deleted.',
    deleteConfirm: 'Delete',
    removeMemberConfirm: 'Are you sure you want to remove {name} from the household?'
  },
  profile: {
    title: 'Profile',
    displayName: 'Display Name',
    email: 'Email',
    role: 'Role',
    settings: 'Settings',
    notifications: 'Notifications',
    syncStatus: 'Sync Status',
    auditLog: 'Audit Log',
    logout: 'Logout',
    deleteAccount: 'Delete Account',
    biometric: 'Biometric Login'
  },
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark All as Read',
    noNotifications: 'No notifications'
  },
  sync: {
    title: 'Sync Status',
    online: 'Online',
    offline: 'Offline',
    syncing: 'Syncing...',
    lastSync: 'Last Synced',
    pending: 'Pending Operations',
    failed: 'Failed Operations',
    retry: 'Retry Failed',
    clearCompleted: 'Clear Completed'
  }
}
